import React from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import { formatLabel, getInputType } from './ModalDetails';

export const FieldInput = ({ fieldKey, value, onChange, displayLabel, disabled, onUpdateImage }) => {
  const label = formatLabel(fieldKey);
  const inputType = getInputType(fieldKey, value);
  const id = `field-${fieldKey}`;

  // 1. Función para extraer el nombre del archivo de la URL
  const getFileNameFromUrl = (url) => {
    if (!url) return '';
    try {
      const urlPath = new URL(url).pathname;
      return urlPath.substring(urlPath.lastIndexOf('/') + 1);
    } catch (e) {
      // Fallback si no es una URL válida: tomar el último segmento tras la barra
      return url.split('/').pop();
    }
  };

  if (fieldKey === 'photo') {
    const hasImage = value && typeof value === 'string' && value.trim().length > 0;
    const fileName = hasImage ? getFileNameFromUrl(value) : null;

    return (
      <FormGroup>
        <Label for={id}>{label}</Label>
        <div className="d-flex flex-column gap-2">
          {hasImage && (
            <div className="mb-2">
              <img
                src={value}
                alt="Vista previa"
                style={{
                  maxWidth: '200px',
                  maxHeight: '200px',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6',
                  objectFit: 'cover',
                }}
              />
              <div className="text-muted small mt-1">
                Archivo: {fileName}
              </div>
            </div>
          )}
          
          <Button 
            color="dark" 
            size="sm" 
            outline
            className="w-50 justify-content-center" 
            onClick={() => onUpdateImage && onUpdateImage(fieldKey, fileName)}
          >
            {hasImage ? 'Actualizar Imagen' : 'Subir Imagen'}
          </Button>
        </div>
      </FormGroup>
    );
  }

  if (inputType === 'checkbox') {
    return (
      <FormGroup 
        check 
        className="mb-3 d-flex align-items-center" 
        style={{ paddingLeft: 0 }} // Quitamos el padding por defecto de Bootstrap
      >
        <div style={{ position: 'relative', display: 'inline-block', width: '40px', height: '24px' }}>
          <Input
            type="checkbox"
            id={id}
            name={fieldKey}
            checked={!!value}
            onChange={(e) => 
              onChange({ target: { name: fieldKey, value: e.target.checked } })
            }
            style={{
              // Reset de apariencia base
              appearance: 'none',
              WebkitAppearance: 'none',
              width: '40px',
              height: '24px',
              backgroundColor: value ? '#000' : '#545458',
              borderRadius: '20px',
              position: 'relative',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              border: 'none',
              margin: 0,
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3ccircle fill='white' cx='10' cy='10' r='9'/%3e%3c/svg%3e")`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '20px',
              backgroundPosition: value ? 'right 2px center' : 'left 2px center',
              outline: 'none',
              boxShadow: 'none'
            }}
          />
        </div>
        <Label 
          check 
          for={id} 
          className="ms-3 mb-0" 
          style={{ cursor: 'pointer', fontWeight: '500', userSelect: 'none' }}
        >
          {label}
        </Label>
      </FormGroup>
    );
  }

  return (
    <FormGroup>
      <Label for={id} className={disabled ? "text-muted" : ""}>
        {label}
      </Label>
      <Input
        type={inputType === 'textarea' ? 'textarea' : inputType}
        id={id}
        name={fieldKey}
        value={value ?? ''}
        onChange={onChange}
        disabled={disabled}
        rows={inputType === 'textarea' ? 3 : undefined}
        style={disabled ? { backgroundColor: '#f8f9fa', cursor: 'not-allowed' } : {}}
      />
    </FormGroup>
  );
};